import { NgModule } from '@angular/core';
import { ToolbarV2Component } from './toolbar-v2.component';

@NgModule({
  imports: [ToolbarV2Component],
  exports: [ToolbarV2Component]
})
export class ToolbarV2Module {}
